import { AppDispatch, RootState } from '..';
import { REACT_APP_COMPANY_SERVICE_ENDPOINT, REACT_APP_MANAGE_SERVICE_ENDPOINT } from '../types';
import { addVehicleLoading, addVehicleSuccess, deleteVehicleLoading, getDriversSuccess, getVehiclesLoading, getVehiclesSuccess, onUpdatingVehicle, vehicleDelete, vehicleLoadingMessage } from '../reducers';

import axios from 'axios';
import { notification } from '../../utils';
import { vehicelType } from '../../types';

const headers = (token: string) => ({
    headers: {
        authorization: `Bearer ${token}`
    }
});

export const fetchVehicles = () => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;
    const { company } = getState().companyReducer;

    dispatch(getVehiclesLoading(true));

    return axios
        .get(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/vehicles/company/${company?.company_id}`, headers(token))
        .then(res => {

            const { vehicles } = res.data;
            dispatch(getVehiclesSuccess(vehicles));
            dispatch(getVehiclesLoading(false));
        })
        .catch(error => {
            dispatch(vehicleLoadingMessage(error));
            dispatch(getVehiclesLoading(false));
        });

};

export const addVehicle = (values: vehicelType) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;
    dispatch(addVehicleLoading(true));

    const { data } = await axios.post(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/vehicle/add`, { ...values, status: 'parked' }, headers(token));

    const { success, message } = data;

    try {
        dispatch(addVehicleSuccess({ success, message }));
        dispatch(addVehicleLoading(false));
        dispatch(fetchVehicles());
        notification(success ? 'success' : 'error', message);
    } catch (error) {
        const { message }: any = error;
        dispatch(addVehicleLoading(false));
        dispatch(addVehicleSuccess({ success, message }));
        notification('error', message);
    }

};

export const getVehicle = async (vehicle_id: string, token: string) => {

    const { data } = await axios.get(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/vehicle/${vehicle_id}`, headers(token));

    const { vehicle } = data;

    return vehicle[0];

};

export const assignDriver = (id: string, values: vehicelType) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/vehicle/${id}/update`, { ...values }, headers(token));

    try {

        const { success, message } = data;

        dispatch(fetchVehicles());
        notification(success ? 'success' : 'error', message);

    } catch (error) {
        const { message }: any = error;
        notification('error', message);
    }
};

export const updateVehicleStatus = (id: string, values: vehicelType) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/vehicle/${id}/update`, { ...values }, headers(token));

    try {

        const { success, message } = data;

        dispatch(fetchVehicles());
        notification(success ? 'success' : 'error', message);

    } catch (error) {
        const { message }: any = error;
        notification('error', message);
    }
};

export const updateVehicleFleetType = (values: { vehicle_id: string; fleet_type: string; }) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/vehicle/update-fleet-type`, { ...values }, headers(token));

    try {

        const { success, message } = data;

        dispatch(fetchVehicles());
        notification(success ? 'success' : 'error', message);

    } catch (error) {
        const { message }: any = error;
        notification('error', message);
    }
};

export const updateVehicle = (values: vehicelType) => async (dispatch: AppDispatch, getState: RootState) => {

    dispatch(onUpdatingVehicle(true));

    const { _id } = values;

    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/vehicle/${_id}/update`, {...values}, headers(token));

    const  { success, message } = data;

    try {

        notification(success ? 'success' : 'error', message);
        dispatch(onUpdatingVehicle(false));
        dispatch(fetchVehicles());
        
    } catch (error: any) {

        notification('error', message);
        dispatch(onUpdatingVehicle(false));
        console.log(error.message);
        
    }

};

export const fetchDrivers = () => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;
    const { company } = getState().companyReducer;

    const { data } = await axios.get(`${REACT_APP_COMPANY_SERVICE_ENDPOINT}/company/${company?.company_id}/drivers`, headers(token));

    try {
        const { drivers } = data;
        dispatch(getDriversSuccess(drivers));
    } catch (error) {
        console.log(error);
    }

};

export const deleteVehicle = (id: string) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;
    dispatch(deleteVehicleLoading(false));

    const { data } = await axios.delete(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/vehicle/${id}/delete`, headers(token));

    const { success, message } = data;

    try {
        dispatch(deleteVehicleLoading(false));
        dispatch(vehicleDelete({ success, message }));
        dispatch(fetchVehicles());
        notification(success ? 'success' : 'error', message);
    } catch (error) {
        const { message }: any = error;
        dispatch(deleteVehicleLoading(false));
        dispatch(vehicleDelete({ success, error }));
        notification('error', message);
    }
};